import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UISubheader from 'UIComponents/layout/UISubheader';
import { device } from '../../constants/StyledComponentConstants';
import LessonCardContainer from '../LessonCard/LessonCardContainer';
import { RecommendationsGrid } from '../../features/recommendations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonsContainer = styled.div.withConfig({
  displayName: "RecommendedLessons__LessonsContainer",
  componentId: "sl9obn-0"
})(["margin-top:24px;@media screen and ", "{padding-left:12px;padding-right:12px;}"], device.tablet);
const RecommendedLessons = ({
  isRequesting,
  lessonIds,
  lessonName,
  onClickLesson
}) => /*#__PURE__*/_jsxs(LessonsContainer, {
  children: [/*#__PURE__*/_jsx(UISubheader, {
    className: "p-y-0 m-y-6",
    details: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.lessonInterstitials.recommendations.body",
      options: {
        lessonName
      }
    }),
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.lessonInterstitials.recommendations.heading"
    })
  }), isRequesting ? /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 370
  }) : /*#__PURE__*/_jsx(RecommendationsGrid, {
    children: lessonIds.map(id => /*#__PURE__*/_jsx(LessonCardContainer, {
      appearsIn: "recommendations",
      lessonId: id,
      onClick: onClickLesson
    }, id))
  })]
});
export default RecommendedLessons;